var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as optionValueFactory from '../../../classes/definitions/optionType/optionValue';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import optionValueSchema from '../../../schemas/optionValueSchema';
import Input from '../../UI/Input/Input';
var OptionValueForm = /** @class */ (function (_super) {
    __extends(OptionValueForm, _super);
    function OptionValueForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.optionTypeId = '';
        _this.editId = '';
        _this.messages = null;
        _this.state = {
            formConfig: _.cloneDeep(optionValueSchema),
            formIsValid: false,
        };
        _this.getOptionValue = function (optionTypeId, optionValueId) {
            _this.api
                .getOptionValue(optionTypeId, optionValueId)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на Option Value';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var optionValue = optionValueFactory.createOptionValue(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'value.value', optionValue.Value);
            _.set(updatedFormConfig, 'value.touched', true);
            _.set(updatedFormConfig, 'value.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedOptionValue = optionValueFactory.createOptionValue({
                value: _.get(formData, 'value.value', '').trim(),
            });
            var actionMethod = _this.editId === '-1' ? _this.api.createOptionValue : _this.api.updateOptionValue;
            actionMethod(submittedOptionValue, _this.optionTypeId, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toOptionValuesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на Option Value';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toOptionValuesPage = function () {
            _this.props.history.push(AppRoutes.optionType.path + '/' + _this.optionTypeId + AppRoutes.optionValues.path);
        };
        return _this;
    }
    OptionValueForm.prototype.componentDidMount = function () {
        this.optionTypeId = _.get(this.props, 'match.params.id', '-1');
        this.editId = _.get(this.props, 'match.params.valueId', '-1');
        // load edit value
        if (this.editId !== '-1' && this.optionTypeId !== '-1') {
            this.getOptionValue(this.optionTypeId, this.editId);
        }
    };
    OptionValueForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toOptionValuesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return OptionValueForm;
}(React.Component));
// @ts-ignore
export default withRouter(OptionValueForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/OptionValues/OptionValueForm/OptionValueForm.tsx
// module id = 381
// module chunks = 0